import axios from 'axios'
import config from '../config/Config'

const {APPID} = config

const getAccessToken = () => {
  const userV2Response = JSON.parse(
    localStorage?.getItem('_GresponseV2')
  )
  if (userV2Response) {
    return userV2Response?.access_token
  } else {
    return undefined
  }
}

export const serviceRequest = (url, method, payload, params) => {
  const accessToken = getAccessToken()

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  }

  let serviceUrl = `${url}?apikey=${APPID}`

  if (params) {
    serviceUrl += `&${params}`
  }

  return axios({
    method: method,
    url: serviceUrl,
    headers: headers,
    data: payload,
  })
}

export const serviceRequestForFileUpload = (url, method, payload, params) => {
  const accessToken = getAccessToken()

  const headers = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  }

  let serviceUrl = `${url}?apikey=${APPID}`

  if (params) {
    serviceUrl += `&${params}`
  }

  return axios({
    method: method,
    url: serviceUrl,
    headers: headers,
    data: payload,
  })
}
